const CheckBoxOnly = ({
    field = '',
    label = '',
    value = false,
    isRequired = false,
    onChange,

}: IPropsCheckBoxOnly) => {

    return (
        <>
            <div style={{ display: "flex", placeContent:'center' }}>
                <div className="check-radio-auto-cr" style={{ width: '30px', position: 'relative' }}>
                    <input type="checkbox" id={field} required={isRequired} name={field} checked={value} onChange={onChange} />
                    <label htmlFor={field} ></label>
                </div>
                 <span className="lbl-input-auto-cr" >
                    <label htmlFor={field}>{label}</label> 
                </span> 
            </div>


        </>
    )
}

export { CheckBoxOnly }